// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js?minimize!../../vue-loader/lib/style-rewriter.js?id=data-v-e36dd9ec!../../vue-loader/lib/selector.js?type=styles&index=0!./PageSizeSelect.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("36e3961a", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-e36dd9ec!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/PageSizeSelect.vue
// module id = 1470
// module chunks = 2